export { CUSTOM_EVENT_SESSION_STORAGE, CUSTOM_EVENT_LOGIN_ACTIONS_ERROR } from "../../middleware/Constants/CustomEvents";

export const CUSTOM_EVENT_SIDEBAR_MENU_UPDATE = "CustomEvent_SideBarMenuUpdate";
